import React, {useEffect} from 'react'
import { Box } from '@mui/material';
import SubTitleTemplate from '../../common/template/SubTitleTemplate';
import TechRsltDetailView from './TechRsltDetailView';
import TechCostList from './TechCostList';
import { useDispatch, useSelector } from 'react-redux';
import { viewTechRslt } from '../../../modules/projectModule/techRslt';
import TechApprovalContainer from '../../../containers/projectmng/support/TechApprovalContainer';

const TechRsltView = ({tech}) => {
  const dispatch = useDispatch();
  const {
    techRslt,
    techRsltCostList,
    approvalList,
  } = useSelector(({ projectModule, auth }) => ({
    user: auth.user,
    techRslt: projectModule.techRslt.techRslt,
    techRsltCostList: projectModule.techRslt.techRsltCostList,
    approvalList: projectModule.techRslt.approvalList,
    approvalLine: projectModule.techRslt.apprUuid,
  }));

  //tech의 workUuid를 가지고 rslt정보를 가져와야함.
  useEffect(() => {
    dispatch(viewTechRslt(tech.rsltUuid));
  }, [dispatch, tech]);

  return (
    <Box>
    <SubTitleTemplate title="기술지원 완료 내역">
     <TechRsltDetailView techRslt={techRslt}/>
    </SubTitleTemplate>
    <SubTitleTemplate title="비용 리스트">
      <TechCostList rsltCosts={techRsltCostList}/>
    </SubTitleTemplate>
    <SubTitleTemplate title="결재 내역">
    <TechApprovalContainer approvalList={approvalList}/>
    </SubTitleTemplate>
    
   

  </Box>
  )
}

export default TechRsltView